var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChannelList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 16.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#999;fill-rule:evenodd;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M14.4,9.6c2,0,3.6,1.6,3.6,3.6s-1.6,3.6-3.6,3.6-3.9-2-3.5-4.2l-5.4-2.1c-.2,1.1-1.2,1.9-2.3,1.9s-2.4-1.1-2.4-2.4,.7-1.9,1.6-2.2L1.4,2.6c-.8,0-1.4-.5-1.4-1.3S.6,0,1.3,0s1.3,.6,1.3,1.3-.3,1-.8,1.2l1.1,5.3c.4,0,.9,0,1.3,.2l3.6-3.3c-.2-.3-.4-.7-.4-1.1,0-1,.8-1.8,1.8-1.8s1.8,.8,1.8,1.8c0,1.5-1.7,2.3-2.8,1.4l-3.5,3.3c.6,.4,1,1.1,1,2l5.4,2.1c.4-1.5,1.8-2.6,3.4-2.6h0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChannelList);
export default __webpack_public_path__ + "static/media/channel-list.07479fe89e6a9af96be16ed7fcbd8167.svg";
export { ForwardRef as ReactComponent };